import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { post } from "../../../actions/general";
import { editUser } from "../../../store/user/actions";

import Form, { InputNumber, Title, Submit, Cancel } from "../../../components/Form";
import Modal from "../../../components/Modal";
import messages from "../messages";
import { IProps } from "./interfaces";

const ChangeNumberValue = ({ changingValue, changingLabel, changingName, close }: IProps) => {
    const dispatch = useDispatch();
    const [value, setValue] = useState(changingValue);
    const [validation, setValidation] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);

    const submit = () => {
        if (!value) {
            setValidation("required");
            return
        }
        setLoading(true);
        dispatch(post("change-" + changingName, { [changingName]: +value }, res => {
            const { data } = res;
            if (data.success) {
                dispatch(editUser(data.user));
                close();
                return;
            } else if (data.unrealBirthyear) {
                setValidation("unrealBirthyear");
            } else if (data.unrealWorkSince) {
                setValidation("unrealWorkSince");
            } else {
                setValidation("unknownError");
            }
            setLoading(false);
        }));
    };
    const changeValue = (e: React.FormEvent<HTMLInputElement>) => {
        setValue(e.currentTarget.value);
        setValidation(undefined);
    };

    return (
        <Modal close={close}>
            <Form disabled={loading}>
                <Title>
                    <FormattedMessage {...messages.modifySomething} values={{ value: changingLabel }} />
                </Title>
                <InputNumber
                    label={changingLabel}
                    validation={validation}
                    value={value}
                    name={"value"}
                    onChange={changeValue}
                    selectAllOnMount
                />
                <Submit onClick={submit} loading={loading}>
                    <FormattedMessage {...messages.modify} />
                </Submit>
                <Cancel onClick={close}>
                    <FormattedMessage {...messages.cancel} />
                </Cancel>
            </Form>
        </Modal>
    );
}

export default ChangeNumberValue;
